module.exports = __webpack_public_path__ + "img/logo-dark.1530b00b.png";